export default __webpack_public_path__ + "static/media/rocket.85c0f6be.svg";